// 배포 환경을 감지하여 적절한 API URL을 반환하는 유틸리티 함수
export const getApiUrl = () => { 
  const hostname = window.location.hostname;
  const protocol = window.location.protocol;
  
  // 개발 환경
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'http://localhost:8080/api';
  }
  
  // 배포 환경 
  return 'https://api.xn--o39ap7bo6pk0bo2x.com/api';
};

// API 기본 URL을 반환하는 함수 (getApiUrl과 동일)
export const getApiBaseUrl = () => {
  return getApiUrl();
};

// WebSocket URL을 반환하는 함수 (SockJS용 - http/https 프로토콜 사용)
export const getWebSocketUrl = () => {
  const hostname = window.location.hostname;
  
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'http://localhost:8080/ws';
  }
  
  // 배포 환경에서는 Render 백엔드 URL 수정
  return 'https://api.xn--o39ap7bo6pk0bo2x.com/ws';
};

// API 연결 상태를 확인하는 함수
export const checkApiHealth = async () => {
  try {
    const apiUrl = getApiUrl();
    
    const response = await fetch(`${apiUrl}/health`, {
      method: 'GET',
      mode: 'cors',
      credentials: 'omit',
      headers: {
        'Accept': 'application/json'
      },
      // 타임아웃 설정 추가 - 30초로 증가
      signal: AbortSignal.timeout(30000) // 30초 타임아웃
    });
    
    if (response.ok) {
      return true;
    } else {
      console.log('API Health Check 실패:', response.status);
      return false;
    }
  } catch (error) {
    // 더 구체적인 에러 로깅
    if (error.name === 'AbortError') {
      console.warn('API Health Check 타임아웃 (30초)');
    } else if (error.name === 'TimeoutError') {
      console.warn('API Health Check 타임아웃 (30초) - 서버 응답 지연');
    } else if (error.name === 'TypeError' && error.message.includes('Failed to fetch')) {
      console.warn('API Health Check 네트워크 오류 - 서버 연결 불가');
    } else {
      console.error('API Health Check 기타 오류:', error);
    }
    
    // Health Check 실패 시에도 false 반환하여 재시도 로직 실행
    return false;
  }
}; 